<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.14 192.14">
  <circle cx="96.07" cy="96.07" r="77.48"/>
  <path style="fill: currentColor"
    d="M90.26 55.97c0,-3.21 2.6,-5.81 5.81,-5.81 3.21,0 5.81,2.6 5.81,5.81l0 34.29 34.9 0c3.21,0 5.81,2.6 5.81,5.81 0,3.21 -2.6,5.81 -5.81,5.81l-40.71 0c-3.21,0 -5.81,-2.6 -5.81,-5.81l0 -40.1z"/>
</svg>
